export default "__VITE_ASSET__uSTwJxPe__"